import Box from "@mui/material/Box";
import {galleryLink} from "../../utils/linkMaker";
import Chip from "@mui/material/Chip";
import {MenuItem, Select, Switch, TextField} from "@mui/material";
import React from "react";
import ImageIcon from '@mui/icons-material/Image';
import VerifiedIcon from '@mui/icons-material/Verified';
import Checkbox from '@mui/material/Checkbox';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import {Link} from "react-router-dom";
import {NumericFormat} from "react-number-format";
import {findIcon, findName} from "../../utils/setUtils";
import Tooltip from "@mui/material/Tooltip";
import {cardNameNormalizer} from "../../utils/normalizer";

const label = {inputProps: {'aria-label': 'Foil'}};

export const conditions = {
    'P': "Poor",
    'PL': "Played",
    'SP': "Slightly Played",
    'G': "Good",
    'EX': "Excellent",
    'NM': "Near Mint",
    'M': "Mint"
}

export const collections = {
    'Main': "Main Collection",
    'Reserved': "Reserved List",
}


export const columns = {
    name: {
        field: 'name',
        headerName: 'Name',
        width: 130,
        component: (name) => {
            const formattedName = name.replace(/[, ]/g, "-");
            return (
                <Link to={`/${formattedName}`}>{name}</Link>
            );
        },
    },
    price: {
        field: 'price', headerName: 'Price', type: 'number', width: 90,
        component: (price, editable, formik) => {
            return !editable ? price.toString().replace('.', ',') + " zł"
                : <NumericFormat size="small"
                                 allowNegative={false}
                                 thousandSeparator={' '}
                                 decimalScale={2}
                                 decimalSeparator={','}
                                 allowedDecimalSeparators={['.', ","]}
                                 customInput={TextField}
                                 id="price"
                                 name="price"
                                 variant={'outlined'}
                                 color={'warning'}
                                 label='Price (zł)'
                                 defaultValue={price}
                                 onChange={formik.handleChange}
                                 value={formik.values.price}
                />
        }
    },
    offerType: {
        field: 'offerType', headerName: 'Offer type',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (type) => (<Chip
            variant={'outlined'}
            color={'warning'}
            label={type ? 'Sell' : 'Want'}
        />)
    },

    // collection: {
    //     field: 'collectionName', headerName: 'Collection',
    //     description: 'This column has a value getter and is not sortable.',
    //     sortable: false,
    //     width: 100,
    //     component: (collection) => (<>{collection}</>)
    // },

    collection: {
        field: 'collectionName', headerName: 'Collection',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (collectionName) => (<>{collectionName}</>)
    },
    product: {
        field: 'cardName', headerName: 'Product',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (cardName, setCode, collectors_number, link) => (
            <Tooltip title={
                <React.Fragment>
                    <Box
                        component="img"
                        sx={{width: "100px"}}
                        src={link}/>
                </React.Fragment>
            } placement="right">
                <Box component={Link} to={`/${setCode}/${collectors_number}/${cardNameNormalizer(cardName)}`}>{cardName}</Box>
            </Tooltip>
        )
    },
    sealed_product: {
        field: 'cardName', headerName: 'Product',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (cardName, id, link) => (
            <Tooltip title={
                <React.Fragment>
                    <Box
                        component="img"
                        sx={{width: "100px"}}
                        src={link}/>
                </React.Fragment>
            } placement="right">
                <Box component={Link} to={`/sealed/${id}`}>{cardName}</Box>
            </Tooltip>
        )
    },
    set: {
        field: 'setCode', headerName: 'Set',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (setCode) => (
            <Tooltip title={findName(setCode)} placement="top">
                <Link to={`/${setCode}`}>
                    <Box sx={{height: 16, width: 16}} component={'img'} src={findIcon(setCode)}/>
                </Link>
            </Tooltip>
        )
    },
    type: {
        field: 'typeLine', headerName: 'Type',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (typeLine) => (<>{typeLine}</>)
    },
    rarity: {
        field: 'rarity', headerName: 'Rarity',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (rarity) => (<>{rarity}</>)
    },
    quantity: {
        field: 'quantity', headerName: 'Quantity', type: 'number', width: 64,
        component: (quantity, editable) => {
            return !editable ? quantity
                : <TextField
                    variant={'outlined'}
                    color={'warning'}
                    label='Quantity'
                    defaultValue={quantity}
                />
        }
    },
    language: {
        field: 'language', headerName: 'Lanuguage',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 100,
        component: (language) => (<>{language}</>)
    },
    active: {
        field: 'active', headerName: 'Active',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        component: (active) => (<Switch
            variant={'outlined'}
            color={'success'}
            checked={active}
        />)
    },
    condition: {
        field: 'condition', headerName: 'Condition', width: 90,
        component: (condition, editable, formik) => {
            return !editable ? (<Chip
                    variant={'outlined'}
                    color={'primary'}
                    label={conditions[condition]}
                />)
                :
                <Select size="small"
                        id="condition"
                        name="condition"
                        value={formik.values.condition}
                        onChange={formik.handleChange}
                        defaultValue={condition}
                        label="Condition"
                >
                    {Object.keys(conditions).map(k => (<MenuItem value={k}>{conditions[k]}</MenuItem>))}
                </Select>
        }
    },
    notes: {
        field: 'notes', headerName: 'Notes', width: 90,
        component: (notes, editable, formik) => {
            return !editable ? notes
                : <TextField size="small"
                             id="notes"
                             name="notes"
                             variant={'outlined'}
                             color={'warning'}
                             label='Notes'
                             defaultValue={notes}
                             onChange={formik.handleChange}
                             value={formik.values.notes}
                />
        }
    },
    foil: {
        field: 'foil', headerName: 'Foil',
        component: (foil, editable, formik) => {
            return !editable
                ? (foil ? <VerifiedIcon color="success"/> : <DoNotDisturbOnIcon color="disabled"/>)
                : <Checkbox {...label} defaultChecked={foil}
                            id="foil"
                            name="foil"
                            value={true}
                            onChange={formik.handleChange}
                            checked={formik.values.foil}
                />
        }
    },
}

export const orderColumns = {
    orderId: {
        field: 'id',
        headerName: 'Id',
        width: 130,
        component: (id) => {
            return (
                <Link to={`/${id}`}>{id}</Link>
            );
        },
    },
}